import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getUserData } from "../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import StoreMenu from "./StoreMenu";
import ButtonLink from "../ButtonLink";
import { getStorePartialBooking } from "../services/StorePartialBooking/StorePartialBooking";

const BRAND = "#1752AA";
const BRAND_LIGHT = "#2B70D7";

const StorePartialBooking = () => {
    const navigate = useNavigate();
    const { storeData } = getUserData();
    const storeId = storeData.id;

    const [partialBookingData, setPartialBookingData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [visible, setVisible] = useState(false);

    const fetchPartialBooking = () => {
        setLoading(true);
        getStorePartialBooking(storeId)
            .then((response) => {
                if (!response.data.error) {
                    setPartialBookingData(response.data || []);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPartialBooking();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex-1 min-h-screen surface-ground">
            {/* Header */}
            <div
                className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
                style={{
                    "--surface-0": "#1752AA",
                }}
            >
                <div className="flex-1 flex ml-3 mr-3">
                    <div className="flex-1 flex ">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                                <i className="pi pi-angle-left" onClick={() => navigate("/PickupJob", {

                                    state: {
                                        navigateThrough: true,
                                    },

                                })} style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}></i>
                            </div>
                        </div>
                        <div className="flex-1 ml-5">
                            <p className="text-white text-2xl font-bold ">
                                Partial Booking
                            </p>
                        </div>
                    </div>



                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => setVisible(true)}
                    >
                        <i
                            className="pi pi-bars"
                            style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
                        ></i>
                    </div>
                </div>
            </div>

            {/* Body */}
            <div className="px-3 py-3">

                {loading ? (
                    <div className="flex flex-column align-items-center justify-content-center py-8">
                        <ProgressSpinner
                            style={{ width: "56px", height: "56px" }}
                            strokeWidth="4"
                            fill="var(--surface-ground)"
                            animationDuration="1s"
                        />
                        <p className="text-color-secondary mt-3">Loading partial bookings…</p>
                    </div>
                ) : partialBookingData.length > 0 ? (
                    <div className="flex flex-column gap-3">
                        {partialBookingData.map((item) => (
                            <div
                                key={item.id}
                                className="surface-card border-round-xl p-3 shadow-1"
                                style={{ border: "1px solid var(--surface-border)" }}
                            >
                                <div className="flex align-items-center">
                                    <div
                                        className="flex align-items-center justify-content-center border-circle mr-3 flex-shrink-0"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            backgroundColor: "#EAF2FE",
                                        }}
                                    >
                                        <i
                                            className="pi pi-user"
                                            style={{ fontSize: "18px", color: BRAND_LIGHT }}
                                        />
                                    </div>

                                    <div className="flex-1 min-w-0">
                                        <p className="text-xs text-color-secondary font-semibold m-0 mb-1">
                                            Customer name
                                        </p>
                                        <p className="text-base font-bold m-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                            {item.customerName || "—"}
                                        </p>
                                    </div>
                                    <div
                                        className="flex align-items-center justify-content-center border-circle mr-3 flex-shrink-0"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            backgroundColor: "#EAF2FE",
                                        }}
                                    >
                                        <i
                                            className="pi pi-phone"
                                            style={{ fontSize: "18px", color: BRAND_LIGHT }}
                                        />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-xs text-color-secondary font-semibold m-0 mb-1">
                                            Customer Mobile
                                        </p>
                                        <p className="text-base font-bold m-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                            {item.customerMobile || "No number provided"}
                                        </p>
                                    </div>

                                    <button
                                        type="button"
                                        aria-label="Edit customer"
                                        onClick={() => navigate("/BookNewOrder", {
                                            state: {
                                                storeCustomerId: item?.storeCustomerId,
                                                navigateThrough: "partialBooking"
                                            },
                                        })}
                                        className="border-none bg-transparent p-2 cursor-pointer flex-shrink-0"
                                    >
                                        <img
                                            src={
                                                "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif"
                                            }
                                            style={{
                                                width: 65,
                                                height: 50,
                                            }}
                                        />
                                    </button>
                                </div>

                                <div
                                    className="my-3"
                                    style={{ height: 1, backgroundColor: "var(--surface-border)" }}
                                />



                                {item.remarks && (
                                    <div
                                        className="border-round-lg p-2 mt-3"
                                        style={{ backgroundColor: "var(--surface-ground)" }}
                                    >
                                        <p className="text-xs text-color-secondary font-semibold m-0 mb-1">
                                            Remarks
                                        </p>
                                        <p className="text-sm m-0">{item.remarks}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-column align-items-center justify-content-center py-8 text-center">
                        <i
                            className="pi pi-inbox text-color-secondary"
                            style={{ fontSize: "48px" }}
                        />
                        <p className="text-xl font-bold mt-3 mb-1">No partial bookings found</p>
                        <p className="text-color-secondary text-sm m-0">
                            New partial bookings for this store will show up here.
                        </p>
                    </div>
                )}
            </div>

            <StoreMenu setVisible={setVisible} visible={visible} />
            <ButtonLink />
        </div>
    );
};

export default StorePartialBooking;
